import React from "react";
import { BadgePercent } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

export const DirectBookingBanner = () => {
  const { t } = useI18n();
  return (
    <div className="bg-brand text-white" data-testid="direct-booking-banner">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-center gap-2.5 text-center">
        <BadgePercent size={16} className="shrink-0 text-white/90" />
        <p className="text-xs sm:text-sm font-medium">
          {t("directBanner.text")}
          <span className="ml-2 hidden sm:inline-flex items-center rounded-full bg-white/20 px-2.5 py-0.5 text-[11px] font-semibold tracking-wide">
            {t("directBanner.badge")}
          </span>
        </p>
      </div>
    </div>
  );
};
